import { capitalize } from 'Data/format.js'

export function getText(status) {
  return status
    .split('_')
    .map(el => capitalize(el))
    .join(' ')
}
